import { render } from "./TheTitle.vue?vue&type=template&id=4fc4900c"
import script from "./TheTitle.vue?vue&type=script&lang=js"
export * from "./TheTitle.vue?vue&type=script&lang=js"

import "./TheTitle.vue?vue&type=style&index=0&id=4fc4900c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__